@if (!formReadonlyMode) {
    <mat-form-field [formGroup]="form"
                    class="mxs-input mxs-date-picker mx-date-picker"
                    [ngClass]="{'hidden': hidden}"
                    [matTooltip]="getValidationHint() | translate"
                    [matTooltipClass]="'mxs-error-ttip'" (click)="picker.open()">
        <mat-label>{{getLabel() | translate}}</mat-label>
        <mat-date-range-input [rangePicker]="picker"
                              [required]="hasRequiredField(listDateRangeFormControl)">
            <input matStartDate [formControlName]="this.fieldName + '_from'" placeholder="Start date"/>
            <input matEndDate [formControlName]="this.fieldName + '_to'" placeholder="End date"/>
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker
                               [calendarHeaderComponent]="isMobile ? null : dateRangeHeaderComponent"
                               (closed)="endDateChanged()"
                               [touchUi]="isMobile"
                               panelClass="mxs-date-range-picker">
            <mat-date-range-picker-actions>
                <button mat-raised-button color="primary" class="action-button-apply" matDateRangePickerApply>OK</button>
            </mat-date-range-picker-actions>
        </mat-date-range-picker>
        @if (startDateFormControl.value && showClearButton) {
            <button matSuffix mat-icon-button type="button"
                    aria-label="Clear"
                    (click)="$event.stopPropagation();resetValue()">
                <mat-icon>close</mat-icon>
            </button>
        }
    </mat-form-field>
}

@if (formReadonlyMode) {
    <mat-list-item [ngClass]="{'hidden': hidden}">
        {{getLabel() | translate}}&nbsp;
        <div class="readonly-text-field-block">
            {{getDisplayValue(form.controls[fieldName + '_from'].value | date) }}&nbsp;-&nbsp;
            {{getDisplayValue(form.controls[fieldName + '_to'].value | date) }}
        </div>
    </mat-list-item>
}
